import Vue from 'vue'
import Router from 'vue-router'
import LoginView from "../views/loginView.vue";
import HomeView from "../views/homeView.vue";
import IndexView from "../views/indexView.vue";
import UserView from "../views/userView.vue";
import AdminView from "../views/adminView.vue";
import LogView from "../views/logView.vue";
import StockImgView from "../views/stockImgView.vue";
import classImgView from "../views/classImgView.vue";
import promotionalView from "../views/promotionalView.vue";
import newproductsView from "../views/newproductsView.vue";
import NoView from "../views/noView.vue";
import indexClassView from "../views/indexClassView.vue";
import DailyActiveUserView from "../views/dailyActiveUserView.vue";
import ProductViewTotalView from "../views/productViewTotalView.vue";
import UserProductDetailView from "../views/userProductDetailView.vue";
import DailyOrderStat from "../views/DailyOrderStat.vue";
import UserConsumeRank from "../views/UserConsumeRank.vue";
import OrderLogDetail from "../views/OrderLogDetail.vue";
import productAuthorization from "../views/productAuthorization.vue";
import MemoView from "../views/memoView.vue";

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/home',
      name: 'home',
      component: HomeView,
      redirect: {name: 'index'},
      children: [{
        path: '/index',
        name: 'index',
        component: IndexView
      }, {
        path: '/memo',
        name: 'memo',
        component: MemoView
      },
        {
        path: '/no',
        name: 'no',
        component: NoView
      }, {
        path: '/user',
        name: 'user',
        component: UserView
      }, {
        path: '/stockImg',
        name: 'stockImg',
        component: StockImgView
      }, {
        path: '/classImg',
        name: 'classImg',
        component: classImgView
      }, {
        path: '/indexClass',
        name: 'indexClass',
        component: indexClassView
      }, {
        path: '/newproducts',
        name: 'newproducts',
        component: newproductsView
      }, {
        path: '/promotional',
        name: 'promotional',
        component: promotionalView
      }, {
        path: '/admin',
        name: 'admin',
        component: AdminView
      }, {
        path: '/log',
        name: 'log',
        component: LogView
      }, {
        path: '/productAuthorization',
        name: 'productAuthorization',
        component: productAuthorization
      },
      //   {
      //   path: '/dau',
      //   name: 'dau',
      //   component: DailyActiveUserView
      // }, {
      //   path: '/productViewTotal',
      //   name: 'productViewTotal',
      //   component: ProductViewTotalView
      // }
      // , {
      //   path: '/userProductDetail',
      //   name: 'userProductDetail',
      //   component: UserProductDetailView
      // }      , {
      //   path: '/DailyOrderStat',
      //   name: 'DailyOrderStat',
      //   component: DailyOrderStat
      // }      , {
      //   path: '/UserConsumeRank',
      //   name: 'UserConsumeRank',
      //   component: UserConsumeRank
      // }      , {
      //   path: '/OrderLogDetail',
      //   name: 'OrderLogDetail',
      //   component: OrderLogDetail
      // }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js